import { Button } from '@accure/ui';

import type { Pagination } from './router/hooks/use-pagination';

export type DocumentsPaginationProps = {
  pagination: Pagination;
};

export function DocumentsPagination({ pagination }: DocumentsPaginationProps) {
  const total = pagination.total;
  const start = Math.max(pagination.page * pagination.pageSize, 0) + 1;
  const end = Math.min(start + pagination.pageSize - 1, total);

  return (
    <nav className="flex items-center justify-between px-4 py-3 sm:px-6">
      <div className="hidden sm:block">
        <p className="text-sm text-gray-700">
          Showing <span className="font-medium">{start}</span> to{' '}
          <span className="font-medium">{end}</span> of{' '}
          <span className="font-medium">{total}</span> results
        </p>
      </div>
      <div className="flex flex-1 justify-between gap-2 sm:justify-end">
        <Button
          variant="ghost"
          disabled={!pagination.prev}
          onClick={pagination.prev}
        >
          Previous
        </Button>
        <Button
          variant="ghost"
          disabled={!pagination.next}
          onClick={pagination.next}
        >
          Next
        </Button>
      </div>
    </nav>
  );
}
